<template>
    <div v-if="visible">
        <div class="tariff" :class="{'active': active, 'selected': selected}" >
            <div class="title">{{ $t('tariffs.' + tariff.slug) }}</div>
            <div class="description">{{ $t('tariffs.descriptions.' + tariff.slug) }}</div>
            <div class="features">
                <b>{{ $t('features') }}</b>
                <ul class="mt-5 list-inside text-sm">
                    <div v-for="feature in tariff.features" :key="feature">
                        • {{ $t('features.'+feature) }}
                    </div>
                </ul>
            </div>

            <div class="details">
                <div class="" v-if="free">
                    {{ $t('free') }}
                </div>
                <div class="" v-if="trial">
                    {{ $t('trialFor') }} {{ $t('periods.'+tariff.period) }}
                </div>
                <div class="" v-if="paid">
                    <div class="line-through text-base" v-if="tariff.crossedPrice">
                        {{ tariff.crossedPrice + ' ' + $t('currency.'+tariff.currency) 
                            + (endless ? '' : ('/' + $t('periods.'+tariff.period))) }}
                    </div>
                    {{ tariff.price + ' ' + $t('currency.'+tariff.currency)
                        + (endless ? (' ' + $t('endless')) : ('/' + $t('periods.'+tariff.period))) }}
                </div>
            </div>
            <div class="px-16 pb-11">
                <div v-if="! selected">
                    <BigButton disable="true" v-if="active">
                        {{ $t('button.active') }}
                    </BigButton>
                    <BigButton v-if="! active" @clicked="select" >
                        {{ $t('button.select') }}
                    </BigButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BigButton from '@/components/visual/BigButton'
import { mapState } from 'vuex'

export default {
    components: { BigButton },
    props: [ 'tariff', 'selected', 'collapsed' ],
    methods: {
        select() {
            if (! this.active && ! this.disabled)
                this.$emit('select')
        },
    },
    computed: {
        active() { 
            return this.tariff.id == this.user.subscription.tariff_id 
        },
        free() { 
            return this.tariff.price == 0 && this.tariff.period == 'endless'
        },
        endless() { 
            return this.tariff.period == 'endless'
        },
        paid() { 
            return this.tariff.price > 0 
        },
        trial() { 
            return this.tariff.price == 0 && ! this.tariff.prolongable && this.tariff.period != 'endless'
        },
        visible() {
            if (this.collapsed && ! this.selected) return false
            if (this.active) return true
            if (! this.tariff.visible) return false
            if (this.disabled) return false
            return true
        },
        disabled() {
            if (this.trial && this.user.hadTrial) return true
            if (this.trial && this.onTrial) return true
            if (this.user.subscription.price > 0 && this.trial) return true
            return false
        },
        ...mapState('auth', ['user']),
        ...mapState('subscription', ['features']),
    },
}
</script>

<i18n locale="ru" lang="yaml">
    free: "Всегда бесплатный"
    trialFor: "Бесплатный на"
    currency:
        RUB: "рублей"
    features: "Возможности"
    button:
        select: "Выбрать"
        active: "Используется"
    endless: "единоразово"
</i18n>

<i18n locale="en" lang="yaml">
</i18n>